export const SITE_KEY_RECAPTCHA = '6Ldq0jUaAAAAAKhCC0l192H7t3Y6bWz2Uu_O_Yuw';